import moment from 'moment-timezone';

export function getTimeZone() {
  const timeZoneContry = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return moment.tz(timeZoneContry).format('z');
}
